import { Controller } from "@hotwired/stimulus"

// パスワード表示/非表示トグルの制御
export default class extends Controller {
  static targets = ["input", "button", "iconOff", "iconOn"]

  toggle() {
    const isPassword = this.inputTarget.type === "password"
    this.inputTarget.type = isPassword ? "text" : "password"

    // アイコンの表示切替
    this.iconOffTarget.classList.toggle("hidden", isPassword)
    this.iconOnTarget.classList.toggle("hidden", !isPassword)

    // アリアラベルの更新
    this.buttonTarget.setAttribute(
      "aria-label",
      isPassword ? this.buttonTarget.dataset.labelHide || "パスワードを非表示" : this.buttonTarget.dataset.labelShow || "パスワードを表示"
    )
  }
}
